import { db } from '@/main';

export default {
    namespaced: true,

    state: {
        countries: []
    },

    getters: {
        countries: state => state.countries,
        country: state => countryId => state.countries.find(item => item.id === countryId),
        countryNamesOnly(state) {
            const items = [];

            state.countries.forEach((country) => {
                items.push({ id: country.id, title: country.id });
            });

            return items;
        },
    },

    mutations: {
        setCountryData(state, countries) {
            state.countries = countries;
        },
    },

    actions: {
        getCountries({ commit }) {
            return new Promise((resolve, reject) => {
                db.collection('countries')
                    .get()
                    .then((snapshot) => {

                        const countrydata = [];

                        if (!snapshot.empty) {
                            snapshot.forEach((doc) => {
                                const json = JSON.parse(JSON.stringify(doc.data()));
                                countrydata.push({ id: doc.id, data: json });
                            });
                        }

                        commit('setCountryData', countrydata);
                        resolve();
                    }).catch((err) => {
                        commit('setCountryData', []);
                        reject(err);
                    });
            })
        },
    }
}